const TOKEN_KEY = 'ancestry_token'
const USER_KEY = 'ancestry_user'

export function getToken(): string | null {
  return localStorage.getItem(TOKEN_KEY)
}

export function setToken(token: string): void {
  localStorage.setItem(TOKEN_KEY, token)
}

export function clearAuth(): void {
  localStorage.removeItem(TOKEN_KEY)
  localStorage.removeItem(USER_KEY)
}

export function getCachedUser() {
  const raw = localStorage.getItem(USER_KEY)
  return raw ? JSON.parse(raw) : null
}

export function setCachedUser(user: { id: string; email: string; name?: string; role?: string; approved?: boolean; plan?: string }): void {
  localStorage.setItem(USER_KEY, JSON.stringify(user))
}

export function isLoggedIn(): boolean {
  return !!getToken()
}

/** What to call someone on screen (v0.21.2, D-129). Was duplicated in three places,
 *  each falling back to the email local part — so a keeper who had set their name
 *  was still greeted as "hrashe2". */
export function displayName(u?: { name?: string | null; email?: string } | null): string {
  const n = (u?.name || '').trim()
  if (n) return n
  return (u?.email || '').split('@')[0] || 'friend'
}
export const firstName = (u?: { name?: string | null; email?: string } | null): string =>
  displayName(u).split(' ')[0]
